import { generateBaseQueryKeysList } from '@/queries/utils';

export const OCS_CONSOLES_KEYS = {
  main: 'ocs-consoles',
};

export const ocsConsolesQueryKeys = generateBaseQueryKeysList(OCS_CONSOLES_KEYS.main);
